const CustomerModel={
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    address: '',
    postnumber: null,
    city: '',
    gender: '',
    birthday: '',
    level: '',
    nationality: '',
    passportnumber: '',
    weight: null,
    shoesize: '',
    height: '',
    comment: '',
    iamalsoaparticipant: false,
    telpattern:8,
    telcode:'',
    
}
const ParticpantModel={
    dummyfirstname:``,
    dummylastname:``,
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    address: '',
    postnumber: null,
    city: '',
    gender: '',
    birthday: '',
    level: '',
    nationality: '',
    passportnumber: '',
    weight: null,
    shoesize: '',
    height: '',
    comment: '',
    fromcustomer:false,
    telpattern:8,
    telcode:'',
    
}
export const getCustomerModel = () =>{
return CustomerModel
}
export const getPartcipantModel=(array=0,isNameAssigned=false,label="")=>{
    if(array>0){
        let participants=[];
        if(isNameAssigned){
            for(let i=0;i<array;i++){
               let part= ParticpantModel;
               part={...part,dummyfirstname:`${label} ${(i+1)}`,isDummy:true};
                participants.push(part);
            }
        }else{
            for(let i=0;i<array;i++){
                participants.push(ParticpantModel);
            }
        }
       
      
        return participants
    }
    return ParticpantModel
}